import React from "react";

// Components
import {
  FormattedMessage,
  MessageDescriptor,
} from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Box } from "@UI/Components/Box/Box";
import { Button } from "@UI/Components/Button/Button";
import { Flex } from "@UI/Components/Flex/Flex";
import { Stack } from "@UI/Components/Stack/Stack";
import { Text } from "@UI/Components/Text/Text";
import { Bold } from "@UI/Components/Bold/Bold";

// Messages
import messages from "./messages";

// Types
import { IUserPaymentMethod } from "@modules/PaymentProcessing/services/paymentMethods";

interface Props {
  onChangeCard: () => void;
  paymentMethod: IUserPaymentMethod;
  stripeError?: MessageDescriptor;
}

export const CreditCardPreview = ({
  onChangeCard,
  paymentMethod,
  stripeError,
}: Props) => {
  const {
    details: { name, last4, expirationDate },
  } = paymentMethod;

  return (
    <Stack spacing={3}>
      <Box
        bgColor="sand.100"
        padding={4}
        data-testid="card-preview"
        borderRadius={10}
        borderWidth="1px"
        borderColor={stripeError ? "error" : "transparent"}
      >
        <Flex flexDirection="row" justifyContent="space-between" mb={2}>
          <Text>
            <FormattedMessage {...messages.cardHolder} />
          </Text>
          <Bold>{String(name)}</Bold>
        </Flex>
        <Flex flexDirection="row" justifyContent="space-between" mb={2}>
          <Text>
            <FormattedMessage {...messages.cardNumber} />
          </Text>
          <Bold>{"•••• " + String(last4)}</Bold>
        </Flex>
        <Flex flexDirection="row" justifyContent="space-between" mb={2}>
          <Text>
            <FormattedMessage {...messages.expirationDate} />
          </Text>
          <Bold>{String(expirationDate)}</Bold>
        </Flex>
      </Box>
      {stripeError && (
        <Box data-testid="stripe-error" color="error">
          <FormattedMessage {...stripeError} />
        </Box>
      )}
      <Button
        variant="link"
        colorScheme="gray"
        paddingX="0"
        mb={3}
        onClick={onChangeCard}
        data-testid="change-card"
      >
        <Text fontSize="sm">
          <FormattedMessage {...messages.modifyCard} />
        </Text>
      </Button>
    </Stack>
  );
};
